export default __webpack_public_path__ + "static/adam-something-aa35668c99faecf7e98929696f861376.png";